import { mmDDYYYY } from '../utils/placeHolderFormat';

//firstName, lastName, dateOfBirth, gender, maritalStatus

const fields = [
    {
        label: 'First name',
        name: 'givenName',
        type: 'text',
        component: 'input',
        placeholder: 'Enter first name',
        validation: 'enter validation properties here',
        help: ''
    },
    {
        label: 'Last name',
        name: 'surname',
        type: 'text',
        component: 'input',
        placeholder: 'Enter last name',
        validation: 'enter validation properties here'
    },
    {
        label: 'Gender',
        name: 'gender',
        type: 'radio',
        component: 'input',
        validation: 'enter validation properties here',
        options: [
            {
                code:'F',
                description: 'Female'
            },
            {
                code:'M',
                description: 'Male'
            },
            {
                code:'N',
                description: 'Gender Neutral'
            }
        ]
    },
    {
        label: 'Marital status',
        name: 'maritalStatus',
        type: 'select',
        component: 'select',
        placeholder: 'Enter last name',
        options: [
            {
                code: 'S',
                description: 'Single'
            },
            {
                code: 'M',
                description: 'Married'
            },
            {
                code: 'P',
                description: 'Divorced'
            },
            {
                code: 'P',
                description: 'Separated'
            },
            {
                code: 'W',
                description: 'Widowed'
            }
        ],
        validation: 'enter validation properties here'
    },
    {
        label: 'Date of birth',
        name: 'dobPrimarySource',
        type: 'text',
        component: 'input',
        placeholder: mmDDYYYY,
        validation: 'enter validation properties here',
    },
    /*
    {
        label: 'Relationship to policyholder',
        name: 'relationToPolicyHolder',
        type: 'select',
        component: 'select',
        //placeholder: mmDDYYYY,
        options: [
            {
                code: 'LD',
                description: 'Listed Driver'
            },
            {
                code: 'SP',
                description: 'Secondary Policyholder'
            },
            {
                code: 'PP',
                description: 'Primary Policyholder'
            }
        ],
        validation: 'enter validation properties here'
    },
    {
        label: 'Relation to insured',
        name: 'relationToInsured',
        type: 'select',
        component: 'select',
        options: [
            {
                code: 'I',
                description: 'Insured'
            }
        ]
    },
    {
        label: 'From date',
        type: 'text',
        placeholder:mmDDYYYY,
        component: 'input',
        name: 'fromDate'
    },
    {
        label: 'To date',
        type: 'text',
        component: 'input',
        placeholder:mmDDYYYY,
        name: 'toDate'
    },
    */
    {
        label: 'Address',
        name: 'address',
        type: 'text',
        component: 'input',
        placeholder: 'Enter a location',
        validation: 'enter validation properties here'
    },
    {
        label: 'Apt #',
        name: 'aptNumber',
        type: 'text',
        component: 'input',
        placeholder: '',
        validation: 'enter validation properties here'
    },
    {
        label: 'City',
        name: 'city',
        type: 'text',
        component: 'input',
        placeholder: 'Enter a location',
        validation: 'enter validation properties here'
    },
    {
        label: 'State',
        name: 'state',
        type: 'text',
        component: 'input',
        placeholder: '',
        validation: 'enter validation properties here'
    },
    {
        label: 'Zip code',
        name: 'zipcode',
        type: 'text',
        component: 'input',
        placeholder: '',
        validation: 'enter validation properties here'
    },
    /*
    {
        label: 'Reason code details',
        name: 'reasonCodeDetails',
        type: 'listitem',
        component: 'checkbox',
        options: [
            {
                "code": "ID-1.09",
                "description": "First Name not validated."
            },
            {
                "code": "ID-1.10",
                "description": "Last Name not validated."
            },
            {
                "code": "ID-1.11",
                "description": "No identity located or poor match on primary data source."
            },
            {
                "code": "ID-1.13",
                "description": "Date of Birth not validated."
            },
            {
                "code": "ID-1.15",
                "description": "No verifiable match found on any consumer provided address"
            },
            {
                "code": "ID-1.17",
                "description": "Phone number not validated"
            },
            {
                "code": "ID-1.37",
                "description": "Name Cannot Be Verified on any Source."
            },
            {
                "code": "ID-1.38",
                "description": "SSN Blank or Invalid"
            },
            {
                "code": "AG-2.15",
                "description": "No verifiable match found on any consumer provided address."
            }
        ]
    },
    
    {
        label: 'actionMessages',
        name: 'actionMessages',
        type: 'listMessage',
        component: 'listMessage',
    }
    */
]


export default fields;


// WEBPACK FOOTER //
// ./src/Driver/fields.js